export class RequestDeadlineError extends Error {
  constructor() {
    super("The request exceeded its time limit");
    this.name = "RequestDeadlineError";
  }
}

/** Bound the entire operation, including response-body consumption. */
export async function withRequestDeadline(operation, timeoutMs) {
  const controller = new AbortController();
  let timer;
  const deadline = new Promise((_, reject) => {
    timer = setTimeout(() => {
      const error = new RequestDeadlineError();
      controller.abort(error);
      reject(error);
    }, timeoutMs);
  });

  try {
    return await Promise.race([
      Promise.resolve().then(() => operation(controller.signal)),
      deadline,
    ]);
  } finally {
    clearTimeout(timer);
  }
}
